import axios from 'axios';

const elementId = 'mainmenutree_0';

const updateStorage = (data) => {
    localStorage.setItem(elementId, JSON.stringify(data));
};

const getMenu = () => {
    return new Promise((resolve) => {
        if (window.localStorage && localStorage.getItem(elementId)) {
            resolve(JSON.parse(localStorage.getItem(elementId)));
        } else {
            axios.get('/mainmenutree/').then(({ data }) => {
                updateStorage(data);
                resolve(data);
            });
        }
    });
};

export { getMenu };
